import styled from '@emotion/styled'
import { type Theme, Typography } from '@mui/material'
import { css } from '@mui/styled-engine'
import { theme as newTheme } from 'styles/theme/hav-theme'

import type { DSTypographyType } from '.'

export const TypographyStyled = styled(Typography)`
  ${({ theme, design, disabled }: { theme?: Theme; design: DSTypographyType; disabled: boolean }) =>
    theme &&
    css`
      display: inline;
      ${
        design === 'hav-h1-text' &&
        css`
        font-size: ${newTheme.typography.sizes['3xl']};
        font-family: ${newTheme.typography.family.bold};
        font-weight: ${newTheme.typography.weight.lg};
      `
      }
      ${
        design === 'hav-h2-text' &&
        css`
        font-size: ${newTheme.typography.sizes['2xl']};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.sm};
      `
      }
      ${
        design === 'hav-h3-text' &&
        css`
        font-size: ${newTheme.typography.sizes.xl};
        font-family: ${newTheme.typography.family.bold};
        font-weight: ${newTheme.typography.weight.lg};
      `
      }
      ${
        design === 'hav-h4-text' &&
        css`
        font-size: ${newTheme.typography.sizes.lg};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.md};
      `
      }
      ${
        design === 'hav-h5-text' &&
        css`
        font-size: ${newTheme.typography.sizes['2md']};
        font-weight: ${newTheme.typography.weight.xl};
        color: ${newTheme.colors.neutral.black} !important;
      `
      }
      ${
        design === 'hav-h6-text' &&
        css`
        font-size: ${newTheme.typography.sizes.sm};
        font-weight: ${newTheme.typography.weight.xl};
        color: ${newTheme.colors.neutral.black} !important;
      `
      }
      ${
        design === 'hav-h7-text' &&
        css`
        font-size: ${newTheme.typography.sizes.xs};
        font-weight: ${newTheme.typography.weight.xl};
        color: ${newTheme.colors.neutral.light} !important;
      `
      }
      ${
        design === 'hav-h8-text' &&
        css`
        font-size: ${newTheme.typography.sizes['2xs']};
        font-weight: ${newTheme.typography.weight.xl};
        color: ${newTheme.colors.neutral.medium} !important;
      `
      }
      ${
        design === 'hav-title-text' &&
        css`
        font-size: ${newTheme.typography.sizes.xm};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.lg};
      `
      }
      ${
        design === 'hav-subtitle-text' &&
        css`
        font-size: ${newTheme.typography.sizes.md};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.md};
      `
      }
      ${
        design === 'hav-default-01-text' &&
        css`
        font-size: ${newTheme.typography.sizes.sm};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.xsm};
        color: ${disabled ? newTheme.colors.neutral.mediumhover : 'inherith'} !important;
      `
      }
      ${
        design === 'hav-default-02-text' &&
        css`
        font-size: ${newTheme.typography.sizes.xs};
        font-family: ${newTheme.typography.family.bold};
        font-weight: ${newTheme.typography.weight.lg};
      `
      }
      ${
        design === 'hav-default-02-disabled' &&
        css`
        font-size: ${newTheme.typography.sizes.xs};
        font-family: ${newTheme.typography.family.bold};
        font-weight: ${newTheme.typography.weight.lg};
        color: ${newTheme.colors.neutral.mediumhover} !important;
      `
      }
      ${
        design === 'hav-default-03-text' &&
        css`
        font-size: ${newTheme.typography.sizes.xs};
        font-family: ${newTheme.typography.family.primary};
        color: ${newTheme.colors.neutral.medium} !important;
      `
      }
      ${
        design === 'hav-default-04-text' &&
        css`
        font-size: ${newTheme.typography.sizes['2xs']};
        font-family: ${newTheme.typography.family.medium};
        color: ${newTheme.colors.neutral.medium} !important;
      `
      }
      ${
        design === 'hav-default-05-text' &&
        css`
        font-size: ${newTheme.typography.sizes['3xs']};
        font-family: ${newTheme.typography.family.primary};
        color: ${newTheme.colors.neutral.medium} !important;
      `
      }
      ${
        design === 'hav-helper-text' &&
        css`
        font-size: ${newTheme.typography.sizes['2xs']};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.md};
        color: ${newTheme.colors.neutral.light} !important;
      `
      }
      ${
        design === 'hav-helper-02-text' &&
        css`
        font-size: ${newTheme.typography.sizes['3xs']};
        font-family: ${newTheme.typography.family.bold};
        font-weight: ${newTheme.typography.weight.lg};
        color: ${newTheme.colors.neutral.light} !important;
      `
      }
      ${
        design === 'accordion-title' &&
        css`
        font-size: ${newTheme.typography.sizes['2md']};
        font-family: ${newTheme.typography.family.bold};
        font-weight: ${newTheme.typography.weight.lg};
        color: ${
          disabled ? newTheme.colors.neutral.mediumhover : newTheme.colors.neutral.black
        } !important;
      `
      }
    `}
`
